import { createPostApi } from "@api/util/createPostApi";

import type { AxiosResponse } from "axios";

import type { IPathBaseParam } from "./path";

const postApis = createPostApi<AxiosResponse<string>, IPathBaseParam, object>(
  "stores.purchaseInvoices.exportHtml",
);

export const exportHtml = {
  ...postApis,
};
